import { useBuilderConfig } from '@ctw/shared/context/builder-config-context';
import { useFeatureFlag } from '@ctw/shared/context/feature-flag-provider';

export function useShowRequestRecords(): boolean {
  const builderConfig = useBuilderConfig();
  const overrideFlag = useFeatureFlag('ctw-show-request-records-override');
  return builderConfig.showRequestRecords || overrideFlag;
}
